import { useLocation } from 'react-router';
import Notebook from '../../components/Notebook/Notebook';
import { useEntityContext } from '../../components/EntityContextSwitch';

export const NotebookRoute = () => {
  const { currentEntity } = useEntityContext();
  const location = useLocation();

  // Check if we should auto-trigger file upload
  const autoUpload = location.state?.autoUpload;

  return <Notebook entityId={currentEntity?.id} autoUpload={autoUpload} />;
};
